import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import phone from "../assets/2024/stickers/CELULAR.png";
import GingerBreadMan from "../assets/2024/stickers/MUNECO-DE-DULCE.png";
import MunecoNieve from "../assets/2024/stickers/MUNECO-DE-NIEVE.png";
import nieve from "../assets/2024/stickers/NIEVE-FONDO.png";
import flavorEng from "../assets/2024/stickers/SABOR-QUE-TE-ACERCA-A-LA-ANVIDAD-eng.png";
import flavor from "../assets/2024/stickers/SABOR-QUE-TE-ACERCA-A-LA-ANVIDAD.png";
import escribeTel from "../assets/2024/stickers/ESCRIBE-TU-NUMERO-DE-CELULAR.png";
import botonLlenarCelualr from "../assets/2024/stickers/BOTON-ESCRIBE-WAPP.png";
import botonEnviar from "../assets/2024/stickers/BOTON-ENVIAR.png";

import s1 from "../assets/2024/stickers/S1.gif";
import s2 from "../assets/2024/stickers/S2.gif";
import s3 from "../assets/2024/stickers/S3.gif";
import s4 from "../assets/2024/stickers/S4.gif";
import s5 from "../assets/2024/stickers/S5.gif";
import s6 from "../assets/2024/stickers/S6.gif";
import s7 from "../assets/2024/stickers/S7.gif";
import s8 from "../assets/2024/stickers/S8.gif";

import s1Eng from "../assets/2024/stickers/s1Eng.gif";
import s2Eng from "../assets/2024/stickers/s2Eng.gif";
import s3Eng from "../assets/2024/stickers/s3Eng.gif";
import s4Eng from "../assets/2024/stickers/s4Eng.gif";
import s5Eng from "../assets/2024/stickers/s5Eng.gif";
import s6Eng from "../assets/2024/stickers/s6Eng.gif";

export const StickersSection = () => {
  const intl = useIntl();
  const [selectedImage, setSelectedImage] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const sticker_list = [
    { image: s1, name: "s1" },
    { image: s2, name: "s2" },
    { image: s3, name: "s3" },
    { image: s4, name: "s4" },
    { image: s5, name: "s5" },
    { image: s6, name: "s6" },
    { image: s7, name: "s7" },
    { image: s8, name: "s8" },
  ];
  const sticker_list_eng = [
    { image: s1Eng, name: "s1Eng" },
    { image: s2Eng, name: "s2Eng" },
    { image: s3Eng, name: "s3Eng" },
    { image: s4Eng, name: "s4Eng" },
    { image: s5Eng, name: "s5Eng" },
    { image: s6Eng, name: "s6Eng" },
  ];
  return (
    <div className="stickers__background">
      <img src={nieve} alt="Imagen fondo nieve" className="sectionBg__nieve" />
      <img
        src={MunecoNieve}
        className=" sectionBg__munecoNieve"
        alt="logo"
      ></img>
      <img
        src={GingerBreadMan}
        className="sectionBg__gingerBreadMan"
        alt="logo"
      ></img>
      <Container className="stickers__margin">
        <Row className="mt-5 mb-5">
          <Col
            xs={6}
            className="mt-3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <img
              alt="Sticker Phone"
              src={intl.locale.includes("es") ? phone : phone}
              className="stickers__phone"
            ></img>
          </Col>
          <Col xs={6} className="mt-5">
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                className="stickers__flavor"
                alt="El sabor que te acerca a la navidad"
                src={intl.locale.includes("es") ? flavor : flavorEng}
              />
            </Row>
            <Row
              style={{
                position: "relative",
                zIndex: "10",
                paddingLeft: "10%",
                paddingRight: "10%",
              }}
            >
              {intl.locale.includes("es") &&
                sticker_list.map((item, index) => {
                  return (
                    <Col xs={3} key={index}>
                      <div
                        className="stickers__stickerHolder"
                        id={selectedImage === item.image ? "selected" : ""}
                        onClick={() => {
                          setSelectedImage(item.image);
                        }}
                      >
                        <img
                          alt={item.name}
                          src={item.image}
                          className="stickers__sticker"
                        />
                      </div>
                    </Col>
                  );
                })}
              {intl.locale.includes("en") &&
                sticker_list_eng.map((item, index) => {
                  return (
                    <Col xs={3} key={index}>
                      <div
                        className="stickers__stickerHolder"
                        id={selectedImage === item.image ? "selected" : ""}
                        onClick={() => {
                          setSelectedImage(item.image);
                        }}
                      >
                        <img
                          alt={item.name}
                          src={item.image}
                          className="stickers__sticker"
                        />
                      </div>
                    </Col>
                  );
                })}
            </Row>
            <Row
              style={{
                position: "relative",
                zIndex: "10",
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                className="stickers__description"
                alt={"Escribe tu telefono"}
                src={intl.locale.includes("es") ? escribeTel : escribeTel}
              ></img>
            </Row>
            <Row
              style={{
                position: "relative",
                zIndex: "10",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="stickers__whatsappNumber">
                <input
                  type="number"
                  className="inputWp"
                  placeholder="Escribe tu celular"
                  value={phoneNumber}
                  onChange={(event) => {
                    setPhoneNumber(event.target.value);
                  }}
                ></input>
                <img
                  className="stickers__botonWhatsapp"
                  src={botonLlenarCelualr}
                  alt="botonLlenarWhatsapp "
                />
              </div>
            </Row>
            <Row
              style={{
                position: "relative",
                zIndex: "10",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                className="stickers__botonEnviar"
                alt="Boton Enviar"
                src={botonEnviar}
              />
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
